'use client'

import { SLIDER_CLASS_NAME } from '@/constants'
import Link from 'next/link'
import s from './supplier-category-slider-card.module.scss'
import cx from 'classnames'
import { Image } from '@/components/v2/atoms/image/image'
import { forwardRef } from 'react'
import dynamic from 'next/dynamic'
const ReactPlayer = dynamic(() => import('react-player'), { ssr: false })

type Props = {
  href: string
  imageUrl?: string
  imageAlt?: string
  title: string
  videoUrl?: string
  headingLevel?: 'h2' | 'h3' | 'h4'
}

export const SupplierCategorySliderCard = forwardRef<HTMLDivElement, Props>(
  ({ href, imageUrl, imageAlt, title, videoUrl, headingLevel: HeadingTag = 'h3' }, ref) => {
    if (!imageUrl && !videoUrl) {
      return null
    }

    const shouldDisplayVideo = videoUrl && !imageUrl
    const shouldDisplayImage = imageUrl && imageAlt && !videoUrl

    return (
      <Link className={cx(SLIDER_CLASS_NAME, s.itemWrapper)} href={href}>
        <div className={s.photoWrapper} ref={ref}>
          {shouldDisplayVideo && (
            <div className={s.video}>
              <ReactPlayer
                url={videoUrl}
                width="100%"
                height="auto"
                playing
                loop
                volume={0}
                muted
                controls={false}
                playsinline
                style={{ aspectRatio: '9/17' }}
              />
            </div>
          )}
          {shouldDisplayImage && (
            <Image
              src={imageUrl}
              alt={imageAlt}
              width={200}
              height={335}
              className={s.image}
            />
          )}
          <div className={s.overlay} />
          <div className={s.textWrapper}>
            <HeadingTag className={s.centeredText}>{title}</HeadingTag>
            <div className={s.viewButton}>VIEW</div>
          </div>
        </div>
      </Link>
    )
  }
)

SupplierCategorySliderCard.displayName = 'SupplierCategorySliderCard'
